<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.boxGroupContext.formVisible, 'events-active': context?.boxGroupContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Groupes de Bannettes"
                createIconText="Ajouter un groupe"
                importDatasourceName="boxgroups"
                (created)="onBoxGroupCreated()"
                (exported)="onBoxGroupsExported()"
                (imported)="onBoxGroupsImported()"
                (helped)="onBoxGroupsHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-box-groups-list
            (itemSelected)="onBoxGroupSelected($event)"
            (itemDisplayed)="onBoxGroupDisplayed($event)"
            (itemEdited)="onBoxGroupEdited($event)"
            (itemDeleted)="onBoxGroupDeleted($event)"
            (itemsSorted)="onBoxGroupsSorted($event)"></app-box-groups-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.boxGroupContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.boxGroupContext.item.getDisplayName()"
                    [id]="context?.boxGroupContext.item.id"
                    (displayed)="onBoxGroupDisplayed(context?.boxGroupContext.item)"
                    (edited)="onBoxGroupEdited(context?.boxGroupContext.item)"
                    (helped)="onBoxGroupsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-box-group-detail [context]="context" (boxGroupUpdated)="onBoxGroupUpdated($event)" (canceled)="onBackToList()"></app-box-group-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
